import { createSlice } from '@reduxjs/toolkit';

const initialStateValue = {
    couponsList: [],
    inventoryProducts: [],
    selectedProductVariants: [],
}

const dropTrackActionSlice = createSlice({
    name: 'dropTrackAction',
    initialState: initialStateValue,
    reducers: {
        setCouponsList: (state, action) => {
            state.couponsList = action.payload;
        },
        setInventoryProducts: (state, action) => {
            state.inventoryProducts = action.payload;
        },
        handleSelectedVariant: (state, action) => {
            const payload = action.payload;
            const exists = state.selectedProductVariants.some(item => item.id === payload.id);
            
            if(exists) {
                state.selectedProductVariants = state.selectedProductVariants.filter(item => item.id !== payload.id);
            }
            else {
                state.selectedProductVariants = [ ...state.selectedProductVariants, payload ];
            }
        },
        setProductVariants: (state, action) => {
            state.selectedProductVariants = [ ...state.selectedProductVariants, ...action.payload];
        }
    },
});

export const {
    setCouponsList,
    setInventoryProducts,
    handleSelectedVariant,
    setProductVariants
} = dropTrackActionSlice.actions;

export default dropTrackActionSlice.reducer;
